"use client";

import type { PitchMiddleware } from "@/app/(application)/(normal)/create/components/input/types";
import { handleKnobVibratoChangeInternal } from "@/components/pitchCorrection/vibratoKnob/handleKnobVibratoChangeInternal";

export const vibratoMiddleware =
  (vibratoLevelZ: number): PitchMiddleware =>
  ({ pitchDiffs }) =>
  (pitches) =>
    vibratoLevelZ === 0 ? pitches : (
      handleKnobVibratoChangeInternal(vibratoLevelZ, 0, pitches, pitchDiffs)
    );
